import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export default function Privacy() {
  return (
    <main data-testid="privacy-page" className="bg-[#0A0A0A] text-white font-body min-h-screen">
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-20 lg:py-28">
        <Link
          to="/"
          data-testid="privacy-back-home"
          className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-white/60 hover:text-[#FF1B91] transition-colors mb-10"
        >
          <ArrowLeft size={14} weight="bold" /> Back to Sweat With Slay
        </Link>
        <p className="text-[11px] uppercase tracking-[0.4em] text-[#FF1B91] font-semibold mb-4">Legal</p>
        <h1 className="font-display font-black uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.9] tracking-tighter mb-8">
          Privacy{" "}
          <span className="font-brush font-normal normal-case text-[#FF1B91] inline-block transform -rotate-2">policy.</span>
        </h1>
        <p className="text-white/50 text-sm mb-12">Last updated: February 2026</p>

        <div className="space-y-8 text-white/80 leading-relaxed text-[15px]">
          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">1. Who we are</h2>
            <p>
              Sweat With Slay (&ldquo;Sweat With Slay,&rdquo; &ldquo;we,&rdquo; &ldquo;us&rdquo;) is an online fitness coaching practice operated by AJ &ldquo;SlayJ.&rdquo; This Privacy Policy explains how we collect, use, and protect your personal information when you visit sweatwithslay.com or engage our coaching services.
            </p>
          </section>

          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">2. What we collect</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Contact info</strong> — name, email, phone (only when you submit an intake form or contact us).</li>
              <li><strong>Health &amp; fitness info</strong> — anything you voluntarily share during intake (goals, injuries, training history).</li>
              <li><strong>Payment info</strong> — handled exclusively by our payment processors (Stripe, PayPal). We never store card details.</li>
              <li><strong>Usage data</strong> — anonymous analytics (PostHog) to understand how visitors use the site.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">3. How we use it</h2>
            <p>
              Your information is used solely to deliver coaching services, respond to your inquiries, send program updates, and improve the site experience. We do not sell, rent, or trade your personal information to third parties.
            </p>
          </section>

          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">4. Third-party tools</h2>
            <p>We use these services to run the business — each has its own privacy policy:</p>
            <ul className="list-disc pl-5 space-y-2 mt-3">
              <li><strong>Everfit</strong> — program delivery, workout tracking</li>
              <li><strong>Jotform</strong> — intake forms</li>
              <li><strong>Stripe</strong> — payment processing</li>
              <li><strong>PostHog</strong> — anonymous site analytics</li>
            </ul>
          </section>

          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">5. Your rights</h2>
            <p>
              You can request a copy of, correction of, or deletion of your personal data at any time. Email{" "}
              <a href="mailto:sweatwithslay@gmail.com" className="text-[#FF1B91] hover:underline">sweatwithslay@gmail.com</a> and we&apos;ll respond within 30 days.
            </p>
          </section>

          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">6. Cookies</h2>
            <p>
              The site uses essential cookies for functionality and anonymous analytics cookies via PostHog. You can disable cookies in your browser, though some features may not work as expected.
            </p>
          </section>

          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">7. Children</h2>
            <p>This site and our services are intended for adults 18+. We do not knowingly collect information from anyone under 18.</p>
          </section>

          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">8. Updates</h2>
            <p>We may update this policy occasionally. Material changes will be announced on this page with a new &ldquo;last updated&rdquo; date.</p>
          </section>

          <section>
            <h2 className="font-body font-semibold text-xl text-white mb-3">9. Contact</h2>
            <p>
              Questions? Reach out:{" "}
              <a href="mailto:sweatwithslay@gmail.com" className="text-[#FF1B91] hover:underline">sweatwithslay@gmail.com</a>
            </p>
          </section>
        </div>
      </div>
    </main>
  );
}
